import type { SVGProps } from "react"

export interface IllustrationProps
  extends Omit<SVGProps<SVGSVGElement>, "children"> {
  src: string
  viewBox: string
  intrinsicWidth: number
  intrinsicHeight: number
}

export function Illustration({
  src,
  viewBox,
  intrinsicWidth,
  intrinsicHeight,
  width,
  height,
  className,
  ...props
}: IllustrationProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      width={width ?? intrinsicWidth}
      height={height ?? intrinsicHeight}
      aria-hidden
      className={className}
      {...props}
    >
      <image
        href={src}
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
      />
    </svg>
  )
}
